<template>
  <div>
    <PageTitle
    :main="$t('gestao-de-grandezas')"
    sub=""
    imagem="dashboard.png"
    />
    <GridGreatness />
  </div>
</template>

<script>
import PageTitle from '../template/PageTitle.vue';
import GridGreatness from "./GridGreatness.vue";

export default {
  name: "Greatness",
  components: { PageTitle, GridGreatness }
}
</script>

<style>

</style>